import React from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Container } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Collection from './CorrespondentManagementCollection';
import Treatment from './CorrespondentManagementTreatment';

const CorrespondentManagement = () => {
  const type = useSelector((state) => state.auth.user?.type || "")

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>거래처 관리 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" breadcrumbItem="거래처 관리" />

          {/* { type === 'emitter' && <Emitter/> } */}
          { type === 'collection' && <Collection/> }
          {/* { type === 'driver' && <Driver/> } */}
          { type === 'treatment' && <Treatment/> }
          {/* { type === 'demand' && <Demand/> } */}
          
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CorrespondentManagement
